import queryString from 'query-string';

export const isAuthExemptedForEnvironment = () => {
  return !!authExemptedEnvironmentalTokenFragments.microToken
}

const extractEnvironmentalAuthExemptedTokens = () => {
  const tokenFragment = queryString.parse(window.location.hash)
  return {
    // idToken - Identification token (jwt) provided by CIP/RAA
    // microToken - Micro token (jwt) provided by OKAPI
    idToken: tokenFragment.idToken,
    microToken: tokenFragment.microToken,
  }
}

const authExemptedEnvironmentalTokenFragments = extractEnvironmentalAuthExemptedTokens()
